<template>
    <table class="notification-table">
        <tbody>
        <tr>
            <td></td>
            <td v-for="(severity, index) in severities" :key="index" class="text-center font-weight-bold">
                {{ $t('notifications.' + severity.toLowerCase()) }}
            </td>
        </tr>
        <tr v-for="(channel, index) in channels" :key="index">
            <td class="font-weight-bold">{{ $t('settings.' + channel) }}</td>
            <td v-for="(severity, severityIndex) in severities" :key="severityIndex">
                <v-checkbox
                        v-model="channelConfigurations[type][channel][severity]"
                />
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import {
  CHANNEL_EMAIL,
  CHANNEL_REALTIME,
  CHANNEL_SMS,
  NOTIFICATIONS_SEVERITY_CRITICAL,
  NOTIFICATIONS_SEVERITY_INFO,
  NOTIFICATIONS_SEVERITY_WARNING
} from "@/helper/constants";

export default {
  name: "ChannelConfiguration",
  props: {
    value: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['Alert', 'Notification'].includes(value);
      }
    }
  },
  data() {
    return {
      channelConfigurations: this.value,
    };
  },
  computed: {
    severities() {
      return [NOTIFICATIONS_SEVERITY_INFO, NOTIFICATIONS_SEVERITY_WARNING, NOTIFICATIONS_SEVERITY_CRITICAL];
    },
    channels() {
      return [CHANNEL_EMAIL, CHANNEL_SMS, CHANNEL_REALTIME];
    }
  },
  watch: {
    channelConfigurations: {
      handler() {
        this.$emit('input', this.channelConfigurations);
      },
      deep: true,
    },
    value: {
      handler() {
        this.channelConfiguration = this.value;
      },
      deep: true,
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "channel-configuration";
</style>